<div id="main-wrapper">

    <!-- Header
      ============================================= -->
    <app-header></app-header>
    <!-- Header end -->

    <!-- Page Header
        ============================================= -->
    <!-- <section class="page-header page-header-text-light bg-secondary">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-8">
                    <h1>{{pageheading}}</h1>
                </div>
            </div>
        </div>
    </section> -->
    <!-- Page Header end -->

    <!-- Content
      ============================================= -->
    <!-- Banner
    ============================================= -->
    <div class="bg-light shadow-md pt-3 pb-3">
        <div id="generic" class="container">
        </div>
    </div><!-- Banner end -->
    <!-- Footer
    ============================================= -->
    <app-footer></app-footer>
    <!-- Footer end -->
</div>